export default "__VITE_ASSET__BmN_AFOM__"